// Maps a Type Curve Details form field ↔ its verification task `path` ↔ the
// HeaderDetail column written on save. `path`/`headerKey` are backend snake_case;
// `draftKey` is the camelCase key in `TypeCurveDraft` (pages/type-curves/types.ts).
//
// Note: `type_curve_status` (path) writes the `status` column; the two fluid
// inputs (gal + bbl) both attach to the single `fluid_intensity_bbl_ft` path.

export interface FieldTaskEntry {
  path: string;
  headerKey: string;
  draftKey: string;
}

export const FIELD_TASK_ENTRIES: FieldTaskEntry[] = [
  { path: 'type_curve_status', headerKey: 'status', draftKey: 'status' },
  {
    path: 'development_type',
    headerKey: 'development_type',
    draftKey: 'developmentType',
  },
  { path: 'vintage_date', headerKey: 'vintage_date', draftKey: 'vintage' },
  {
    path: 'lateral_length_ft',
    headerKey: 'lateral_length_ft',
    draftKey: 'lateralLength',
  },
  { path: 'formation', headerKey: 'formation', draftKey: 'formation' },
  {
    path: 'well_spacing_ft',
    headerKey: 'well_spacing_ft',
    draftKey: 'wellSpacing',
  },
  {
    path: 'proppant_intensity_lbs_ft',
    headerKey: 'proppant_intensity_lbs_ft',
    draftKey: 'proppantIntensity',
  },
  {
    path: 'fluid_intensity_bbl_ft',
    headerKey: 'fluid_intensity_bbl_ft',
    draftKey: 'fluidIntensityBbl',
  },
  {
    path: 'operator_names',
    headerKey: 'operator_names',
    draftKey: 'operators',
  },
];

export const FIELD_TASK_BY_PATH: Record<string, FieldTaskEntry> =
  Object.fromEntries(FIELD_TASK_ENTRIES.map((e) => [e.path, e]));

export const isFieldBackedPath = (path: string): boolean =>
  path in FIELD_TASK_BY_PATH;
